import { IGenre } from 'services/api/entities';
import { DEFAULT_FORMULA_VALUES } from './constants';
import { AIStore, FormulaFields } from './types';

export const getGenre = (state: AIStore): IGenre | null => {
  const { genres, primaryGenre, microGenre } = state;

  const genre = genres.find(({ name }) => name === primaryGenre) ?? null;

  if (!microGenre) {
    return genre;
  }
  return genre?.microGenres.find(({ name }) => name === microGenre) ?? null;
};

export const getRecommendedBpmValue = (state: AIStore): number => {
  const currentGenre = getGenre(state);

  const { recommendedBpm } = currentGenre ?? {};
  if (!recommendedBpm) {
    return DEFAULT_FORMULA_VALUES[FormulaFields.Bpm];
  }
  return Math.round((recommendedBpm.low + recommendedBpm.high) / 2);
};

export const getRecommendedInstruments = (state: AIStore) => {
  const currentGenre = getGenre(state);

  const { recommendedInstruments } = currentGenre ?? {};
  if (!recommendedInstruments) {
    return {};
  }
  return recommendedInstruments;
};
